import React from 'react';
import LazyImage from '../../components/LazyImage';
import { DEFAULT_USER_AVATAR } from '../../shared/constants/common';
import { formatAmountWithTwoDecimalPlaces, formatDateTimeZone } from '../../shared/utils/function';

const formatReferralDate = (item) => {
  if (!item?.referralDate) return 'N/A';
  return formatDateTimeZone(item.referralDate);
};

const formatUsername = (username) => (username ? `@${username}` : 'N/A');

const ReferralCard = ({ item, index }) => {
  if (!item) return null;

  return (
    <div className='your_ref_card'>
      <LazyImage
        src={item?.user?.profile_picture || DEFAULT_USER_AVATAR}
        alt='user'
      />
      <div className='cm_reff_user'>
        <p>
          <b>{formatUsername(item?.username)}</b>
        </p>
        <small>{formatReferralDate(item)}</small>
      </div>
      <div className='cm_reff_detail'>
        <p>
          <b>${formatAmountWithTwoDecimalPlaces(item?.user?.referral_amount)}</b>
        </p>
        <small className='cm_earned'>earned</small>
      </div>
    </div>
  );
};

export default ReferralCard;

